import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-bottom">
                <div className="container">
                    <p className="copyright">
                        &copy; 2024 <a href="https://www.ebizframe.com/">Atlantic Catering</a>
                    </p>
                    <ul className="footer-bottom-list">
                        <li>
                            <a href="https://www.ebizframe.com/" className="footer-bottom-link">developed by ebizframe</a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
